import type { GabBooking } from "../models/GabModule";

/**
 * TODO capienza massima delle giornate.
 * Index = new Date().getDay(), 0 = sunday
 * Value = Number of hours (slots of the day)
 */
export const temporaryDayHours = [
    [],
    [7, 18],
    [7, 18],
    [7, 18],
    [7, 18],
    [7, 18],
    [7, 18],
];

export const bookingSlotList: Array<keyof GabBooking> = ['slot1', 'slot2', 'slot3', 'slot4'];

export const bookingSlotTime = (60 / bookingSlotList.length) * 60000;
